var items = {
  "block.minecraft.air": "vozduh",
  "block.minecraft.stone": "kamenj",
  "block.minecraft.granite": "granit",
  "block.minecraft.polished_granite": "polirany granit",
  "block.minecraft.diorite": "diorit",
  "block.minecraft.polished_diorite": "polirany diorit",
  "block.minecraft.andesite": "andezit",
  "block.minecraft.polished_andesite": "polirany andezit",
  "block.minecraft.grass_block": "blok travy",
  "block.minecraft.dirt": "zemja",
  "block.minecraft.coarse_dirt": "hrapava zemja",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "bagrova nezgribja",
  "block.minecraft.warped_nylium": "izvračena podgribja",
  "block.minecraft.cobblestone": "poděleny kamenj",
  "block.minecraft.oak_planks": "dubove dosky",
  "block.minecraft.spruce_planks": "smrěkove dosky",
  "block.minecraft.birch_planks": "brězove dosky",
  "block.minecraft.jungle_planks": "džunglove dosky",
  "block.minecraft.acacia_planks": "akacove dosky",
  "block.minecraft.dark_oak_planks": "mračnodubove dosky",
  "block.minecraft.crimson_planks": "bagrove dosky",
  "block.minecraft.warped_planks": "izvračene dosky",
  "block.minecraft.oak_sapling": "dubovy rastok",
  "block.minecraft.spruce_sapling": "smrěkovy rastok",
  "block.minecraft.birch_sapling": "brězovy rastok",
  "block.minecraft.jungle_sapling": "džunglovy rastok",
  "block.minecraft.acacia_sapling": "akacovy rastok",
  "block.minecraft.dark_oak_sapling": "mračnodubovy rastok",
  "block.minecraft.bedrock": "nedobry kamenj",
  "block.minecraft.sand": "pěsok",
  "block.minecraft.red_sand": "črveny pěsok",
  "block.minecraft.gravel": "drobjenec",
  "block.minecraft.gold_ore": "zlata ruda",
  "block.minecraft.iron_ore": "želězna ruda",
  "block.minecraft.coal_ore": "vugoljna ruda",
  "block.minecraft.nether_gold_ore": "zlata ruda nezera",
  "block.minecraft.oak_log": "dubova klada",
  "block.minecraft.spruce_log": "smrěkova klada",
  "block.minecraft.birch_log": "brězova klada",
  "block.minecraft.jungle_log": "džunglova klada",
  "block.minecraft.acacia_log": "akacova klada",
  "block.minecraft.dark_oak_log": "mračnodubova klada",
  "block.minecraft.crimson_stem": "bagrovo steblo",
  "block.minecraft.warped_stem": "izvračeno steblo",
  "block.minecraft.stripped_oak_log": "tesana dubova klada",
  "block.minecraft.stripped_spruce_log": "tesana smrěkova klada",
  "block.minecraft.stripped_birch_log": "tesana brězova klada",
  "block.minecraft.stripped_jungle_log": "tesana džunglova klada",
  "block.minecraft.stripped_acacia_log": "tesana akacova klada",
  "block.minecraft.stripped_dark_oak_log": "tesana mračnodubova klada",
  "block.minecraft.stripped_crimson_stem": "tesano bagrovo steblo",
  "block.minecraft.stripped_warped_stem": "tesano izvračeno steblo",
  "block.minecraft.stripped_oak_wood": "tesano dubovo drěvo",
  "block.minecraft.stripped_spruce_wood": "tesano smrěkovo drěvo",
  "block.minecraft.stripped_birch_wood": "tesano brězovo drěvo",
  "block.minecraft.stripped_jungle_wood": "tesano džunglovo drěvo",
  "block.minecraft.stripped_acacia_wood": "tesano akacovo drěvo",
  "block.minecraft.stripped_dark_oak_wood": "tesano mračnodubovo drěvo",
  "block.minecraft.stripped_crimson_hyphae": "tesane bagrove hify",
  "block.minecraft.stripped_warped_hyphae": "tesane izvračene hify",
  "block.minecraft.oak_wood": "dubovo drěvo",
  "block.minecraft.spruce_wood": "smrěkovo drěvo",
  "block.minecraft.birch_wood": "brězovo drěvo",
  "block.minecraft.jungle_wood": "džunglovo drěvo",
  "block.minecraft.acacia_wood": "akacovo drěvo",
  "block.minecraft.dark_oak_wood": "mračnodubovo drěvo",
  "block.minecraft.crimson_hyphae": "bagrove hify",
  "block.minecraft.warped_hyphae": "izvračene hify",
  "block.minecraft.oak_leaves": "dubove listy",
  "block.minecraft.spruce_leaves": "smrěkove listy",
  "block.minecraft.birch_leaves": "brězove listy",
  "block.minecraft.jungle_leaves": "džunglove listy",
  "block.minecraft.acacia_leaves": "akacove listy",
  "block.minecraft.dark_oak_leaves": "mračnodubove listy",
  "block.minecraft.sponge": "guba",
  "block.minecraft.wet_sponge": "mokra guba",
  "block.minecraft.glass": "steklo",
  "block.minecraft.lapis_ore": "lazuritova ruda",
  "block.minecraft.lapis_block": "blok lazurita",
  "block.minecraft.dispenser": "izkydatnik",
  "block.minecraft.sandstone": "pěsočny kamenj",
  "block.minecraft.chiseled_sandstone": "vrubany pěsočny kamenj",
  "block.minecraft.cut_sandstone": "pileny pěsočny kamenj",
  "block.minecraft.note_block": "notny blok",
  "block.minecraft.powered_rail": "napajatna kolěja",
  "block.minecraft.detector_rail": "senzorova kolěja",
  "block.minecraft.sticky_piston": "lěpky poršenj",
  "block.minecraft.cobweb": "pavučina",
  "block.minecraft.grass": "trava",
  "block.minecraft.fern": "paprat",
  "block.minecraft.dead_bush": "suhy kust",
  "block.minecraft.seagrass": "morska trava",
  "block.minecraft.sea_pickle": "ognitelka",
  "block.minecraft.piston": "poršenj",
  "block.minecraft.white_wool": "běla volna",
  "block.minecraft.orange_wool": "oranževa volna",
  "block.minecraft.magenta_wool": "purpurna volna",
  "block.minecraft.light_blue_wool": "světlomodra volna",
  "block.minecraft.yellow_wool": "žolta volna",
  "block.minecraft.lime_wool": "světlozelena volna",
  "block.minecraft.pink_wool": "rozova volna",
  "block.minecraft.gray_wool": "siva volna",
  "block.minecraft.light_gray_wool": "jasnosiva volna",
  "block.minecraft.cyan_wool": "turkysova volna",
  "block.minecraft.purple_wool": "fioletova volna",
  "block.minecraft.blue_wool": "modra volna",
  "block.minecraft.brown_wool": "koričneva volna",
  "block.minecraft.green_wool": "zelena volna",
  "block.minecraft.red_wool": "črvena volna",
  "block.minecraft.black_wool": "črna volna",
  "block.minecraft.dandelion": "dmuhavec",
  "block.minecraft.poppy": "mak",
  "block.minecraft.blue_orchid": "modra orhideja",
  "block.minecraft.allium": "česnok",
  "block.minecraft.azure_bluet": "modra haustonja",
  "block.minecraft.red_tulip": "črveny tulipan",
  "block.minecraft.orange_tulip": "oranževy tulipan",
  "block.minecraft.white_tulip": "běly tulipan",
  "block.minecraft.pink_tulip": "rozovy tulipan",
  "block.minecraft.oxeye_daisy": "romaška",
  "block.minecraft.cornflower": "sinij vasiljok",
  "block.minecraft.lily_of_the_valley": "landiš",
  "block.minecraft.wither_rose": "roza vizera",
  "block.minecraft.brown_mushroom": "borovik",
  "block.minecraft.red_mushroom": "muhomor",
  "block.minecraft.crimson_fungus": "bagrovy grib",
  "block.minecraft.warped_fungus": "izvračeny grib",
  "block.minecraft.crimson_roots": "bagrove koreni",
  "block.minecraft.warped_roots": "izvračene koreni",
  "block.minecraft.nether_sprouts": "rastoky nezera",
  "block.minecraft.weeping_vines": "plačuče polzavice",
  "block.minecraft.twisting_vines": "vijuče polzavice",
  "block.minecraft.sugar_cane": "cukrova trtina",
  "block.minecraft.kelp": "vodorast",
  "block.minecraft.bamboo": "bambus",
  "block.minecraft.gold_block": "blok zlata",
  "block.minecraft.iron_block": "blok želěza",
  "block.minecraft.oak_slab": "dubovy platform",
  "block.minecraft.spruce_slab": "smrěkovy platform",
  "block.minecraft.birch_slab": "brězovy platform",
  "block.minecraft.jungle_slab": "džunglovy platform",
  "block.minecraft.acacia_slab": "akacovy platform",
  "block.minecraft.dark_oak_slab": "mračnodubovy platform",
  "block.minecraft.crimson_slab": "bagrovy platform",
  "block.minecraft.warped_slab": "izvračeny platform",
  "block.minecraft.stone_slab": "kamenny platform",
  "block.minecraft.smooth_stone_slab": "gladky kamenny platform",
  "block.minecraft.sandstone_slab": "pěsočny kamenny platform",
  "block.minecraft.cut_sandstone_slab": "pileny pěsočny kamenny platform",
  "block.minecraft.petrified_oak_slab": "skameněly dubovy platform",
  "block.minecraft.cobblestone_slab": "poděleny kamenny platform",
  "block.minecraft.brick_slab": "cegleny platform",
  "block.minecraft.stone_brick_slab": "kamenny cegleny platform",
  "block.minecraft.nether_brick_slab": "nezerovy cegleny platform",
  "block.minecraft.quartz_slab": "kvarcovy platform",
  "block.minecraft.red_sandstone_slab": "črveny pěsočny kamenny platform",
  "block.minecraft.cut_red_sandstone_slab": "pileny črveny pěsočny kamenny platform",
  "block.minecraft.purpur_slab": "purpurovy platform",
  "block.minecraft.prismarine_slab": "prizmarinovy platform",
  "block.minecraft.prismarine_brick_slab": "prizmarinovy cegleny platform",
  "block.minecraft.dark_prismarine_slab": "temnoprizmarinovy platform",
  "block.minecraft.smooth_quartz": "gladka kostka kvarceva",
  "block.minecraft.smooth_red_sandstone": "gladky črveny pěsočny kamenj",
  "block.minecraft.smooth_sandstone": "gladky pěsočny kamenj",
  "block.minecraft.smooth_stone": "gladky kamenj",
  "block.minecraft.bricks": "cegly",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "polica",
  "block.minecraft.mossy_cobblestone": "travny poděleny kamenj",
  "block.minecraft.obsidian": "obsidian",
  "block.minecraft.torch": "faklja",
  "block.minecraft.end_rod": "endova rozga",
  "block.minecraft.chorus_plant": "steblo horusa",
  "block.minecraft.chorus_flower": "cvět horusa",
  "block.minecraft.purpur_block": "blok purpura",
  "block.minecraft.purpur_pillar": "stolp purpura",
  "block.minecraft.purpur_stairs": "purpurove stupenišče",
  "block.minecraft.spawner": "stvorišče",
  "block.minecraft.oak_stairs": "dubove stupenišče",
  "block.minecraft.chest": "skrinja",
  "block.minecraft.diamond_ore": "diamantova ruda",
  "block.minecraft.diamond_block": "blok diamanta",
  "block.minecraft.crafting_table": "vrštat",
  "block.minecraft.farmland": "oranica",
  "block.minecraft.furnace": "peč",
  "block.minecraft.ladder": "drabina",
  "block.minecraft.rail": "kolěja",
  "block.minecraft.cobblestone_stairs": "podělene kamenne stupenišče",
  "block.minecraft.lever": "držka",
  "block.minecraft.stone_pressure_plate": "kamenny pritiskany platform",
  "block.minecraft.oak_pressure_plate": "dubovy pritiskany platform",
  "block.minecraft.spruce_pressure_plate": "smrěkovy pritiskany platform",
  "block.minecraft.birch_pressure_plate": "brězovy pritiskany platform",
  "block.minecraft.jungle_pressure_plate": "džunglovy pritiskany platform",
  "block.minecraft.acacia_pressure_plate": "akacovy pritiskany platform",
  "block.minecraft.dark_oak_pressure_plate": "mračnodubovy pritiskany platform",
  "block.minecraft.crimson_pressure_plate": "bagrovy pritiskany platform",
  "block.minecraft.warped_pressure_plate": "izvračeny pritiskany platform",
  "block.minecraft.polished_blackstone_pressure_plate": "polirany črnitovy pritiskany platform",
  "block.minecraft.redstone_ore": "redstounova ruda",
  "block.minecraft.redstone_torch": "redstounova faklja",
  "block.minecraft.snow": "sněg",
  "block.minecraft.ice": "led",
  "block.minecraft.snow_block": "blok sněgu",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "glina",
  "block.minecraft.jukebox": "igrajuča skrinja",
  "block.minecraft.oak_fence": "dubova ograda",
  "block.minecraft.spruce_fence": "smrěkova ograda",
  "block.minecraft.birch_fence": "brězova ograda",
  "block.minecraft.jungle_fence": "džunglova ograda",
  "block.minecraft.acacia_fence": "akacova ograda",
  "block.minecraft.dark_oak_fence": "mračnodubova ograda",
  "block.minecraft.crimson_fence": "bagrova ograda",
  "block.minecraft.warped_fence": "izvračena ograda",
  "block.minecraft.pumpkin": "tykva",
  "block.minecraft.carved_pumpkin": "izrězana tykva",
  "block.minecraft.netherrack": "nezerak",
  "block.minecraft.soul_sand": "pěsok duš",
  "block.minecraft.soul_soil": "zemja duš",
  "block.minecraft.basalt": "bazalt",
  "block.minecraft.polished_basalt": "polirany bazalt",
  "block.minecraft.soul_torch": "faklja duš",
  "block.minecraft.glowstone": "světlokamenj",
  "block.minecraft.jack_o_lantern": "tykvova světilka",
  "block.minecraft.oak_trapdoor": "dubovy otvor",
  "block.minecraft.spruce_trapdoor": "smrěkovy otvor",
  "block.minecraft.birch_trapdoor": "brězovy otvor",
  "block.minecraft.jungle_trapdoor": "džunglovy otvor",
  "block.minecraft.acacia_trapdoor": "akacovy otvor",
  "block.minecraft.dark_oak_trapdoor": "mračnodubovy otvor",
  "block.minecraft.crimson_trapdoor": "bagrovy otvor",
  "block.minecraft.warped_trapdoor": "izvračeny otvor",
  "block.minecraft.infested_stone": "zaražany kamenj",
  "block.minecraft.infested_cobblestone": "zaražany poděleny kamenj",
  "block.minecraft.infested_stone_bricks": "zaražane kamenne cegly",
  "block.minecraft.infested_mossy_stone_bricks": "zaražane travne kamenne cegly",
  "block.minecraft.infested_cracked_stone_bricks": "zaražane razdrobjane kamenne cegly",
  "block.minecraft.infested_chiseled_stone_bricks": "zaražane polirane kamenne cegly",
  "block.minecraft.stone_bricks": "kamenne cegly",
  "block.minecraft.mossy_stone_bricks": "travne kamenne cegly",
  "block.minecraft.cracked_stone_bricks": "razdrobjane kamenne cegly",
  "block.minecraft.chiseled_stone_bricks": "vrubane kamenne cegly",
  "block.minecraft.brown_mushroom_block": "blok borovika",
  "block.minecraft.red_mushroom_block": "blok muhomora",
  "block.minecraft.mushroom_stem": "val griba",
  "block.minecraft.iron_bars": "želězne pruty",
  "block.minecraft.chain": "poslědovateljny",
  "block.minecraft.glass_pane": "steklěny panel",
  "block.minecraft.melon": "dynja",
  "block.minecraft.vine": "polzavice",
  "block.minecraft.oak_fence_gate": "dubove vrata",
  "block.minecraft.spruce_fence_gate": "smrěkove vrata",
  "block.minecraft.birch_fence_gate": "brězove vrata",
  "block.minecraft.jungle_fence_gate": "džunglove vrata",
  "block.minecraft.acacia_fence_gate": "akacove vrata",
  "block.minecraft.dark_oak_fence_gate": "mračnodubove vrata",
  "block.minecraft.crimson_fence_gate": "bagrove vrata",
  "block.minecraft.warped_fence_gate": "izvračene vrata",
  "block.minecraft.brick_stairs": "ceglene stupenišče",
  "block.minecraft.stone_brick_stairs": "kamenne ceglene stupenišče",
  "block.minecraft.mycelium": "podgribja",
  "block.minecraft.lily_pad": "lekvanj",
  "block.minecraft.nether_bricks": "nezerove cegly",
  "block.minecraft.cracked_nether_bricks": "razdrobjene nezerove cegly",
  "block.minecraft.chiseled_nether_bricks": "vrubane nezerove cegly",
  "block.minecraft.nether_brick_fence": "nezerova ceglena ograda",
  "block.minecraft.nether_brick_stairs": "nezerove ceglene stupenišče",
  "block.minecraft.enchanting_table": "čarovny stol",
  "block.minecraft.end_portal_frame": "rama prohodu v endu",
  "block.minecraft.end_stone": "kamenj enda",
  "block.minecraft.end_stone_bricks": "kamenne cegly enda",
  "block.minecraft.dragon_egg": "jajce drakona",
  "block.minecraft.redstone_lamp": "redstounova lampa",
  "block.minecraft.sandstone_stairs": "pěsočne kamenne stupenišče",
  "block.minecraft.emerald_ore": "smaragdova ruda",
  "block.minecraft.ender_chest": "skrinja endera",
  "block.minecraft.tripwire_hook": "hak na provod",
  "block.minecraft.emerald_block": "blok smaragda",
  "block.minecraft.spruce_stairs": "smrěkove stupenišče",
  "block.minecraft.birch_stairs": "brězove stupenišče",
  "block.minecraft.jungle_stairs": "džunglove stupenišče",
  "block.minecraft.crimson_stairs": "bagrove stupenišče",
  "block.minecraft.warped_stairs": "izvračene stupenišče",
  "block.minecraft.command_block": "blok prikazov",
  "block.minecraft.beacon": "světilnik",
  "block.minecraft.cobblestone_wall": "podělena kamenna stěna",
  "block.minecraft.mossy_cobblestone_wall": "travna podělena kamenna stěna",
  "block.minecraft.brick_wall": "ceglena stěna",
  "block.minecraft.prismarine_wall": "prizmarinova stěna",
  "block.minecraft.red_sandstone_wall": "črvena pěsočna kamenna stěna",
  "block.minecraft.mossy_stone_brick_wall": "travna kamenna ceglena stěna",
  "block.minecraft.granite_wall": "granitova stěna",
  "block.minecraft.stone_brick_wall": "kamenna ceglena stěna",
  "block.minecraft.nether_brick_wall": "nezerova stěna",
  "block.minecraft.andesite_wall": "andezitova stěna",
  "block.minecraft.red_nether_brick_wall": "črvena nezerova stěna",
  "block.minecraft.sandstone_wall": "pěsočna kamenna stěna",
  "block.minecraft.end_stone_brick_wall": "kamenne cegly enda enda",
  "block.minecraft.diorite_wall": "dioritova stěna",
  "block.minecraft.blackstone_wall": "črnitova stěna",
  "block.minecraft.polished_blackstone_wall": "polirana črnitova stěna",
  "block.minecraft.polished_blackstone_brick_wall": "polirana črnitova ceglena stěna",
  "block.minecraft.stone_button": "kamenny klaviš",
  "block.minecraft.oak_button": "dubovy klaviš",
  "block.minecraft.spruce_button": "smrěkovy klaviš",
  "block.minecraft.birch_button": "brězovy klaviš",
  "block.minecraft.jungle_button": "džunglovy klaviš",
  "block.minecraft.acacia_button": "akacovy klaviš",
  "block.minecraft.dark_oak_button": "mračnodubovy klaviš",
  "block.minecraft.crimson_button": "bagrovy klaviš",
  "block.minecraft.warped_button": "izvračeny klaviš",
  "block.minecraft.polished_blackstone_button": "polirany črnitovy klaviš",
  "block.minecraft.anvil": "nakovaljnja",
  "block.minecraft.chipped_anvil": "vyščrbena nakovaljnja",
  "block.minecraft.damaged_anvil": "poškodžena nakovaljnja",
  "block.minecraft.trapped_chest": "past-skladišče",
  "block.minecraft.light_weighted_pressure_plate": "legky pritiskany platform",
  "block.minecraft.heavy_weighted_pressure_plate": "težky pritiskany platform",
  "block.minecraft.daylight_detector": "senzor dennogo světla",
  "block.minecraft.redstone_block": "blok redstouna",
  "block.minecraft.nether_quartz_ore": "kvarcova ruda",
  "block.minecraft.hopper": "nasypnik",
  "block.minecraft.chiseled_quartz_block": "vrubany blok kvarca",
  "block.minecraft.quartz_block": "blok kvarca",
  "block.minecraft.quartz_bricks": "kvarcove cegly",
  "block.minecraft.quartz_pillar": "kvarcovy stolp",
  "block.minecraft.quartz_stairs": "kvarcove stupenišče",
  "block.minecraft.activator_rail": "aktivujuča kolěja",
  "block.minecraft.dropper": "izdavač",
  "block.minecraft.white_terracotta": "běla terakota",
  "block.minecraft.orange_terracotta": "oranževa terakota",
  "block.minecraft.magenta_terracotta": "purpurna terakota",
  "block.minecraft.light_blue_terracotta": "světlomodra terakota",
  "block.minecraft.yellow_terracotta": "žolta terakota",
  "block.minecraft.lime_terracotta": "jasnozelena terakota",
  "block.minecraft.pink_terracotta": "rozova terakota",
  "block.minecraft.gray_terracotta": "siva terakota",
  "block.minecraft.light_gray_terracotta": "jasnosiva terakota",
  "block.minecraft.cyan_terracotta": "turkysova terakota",
  "block.minecraft.purple_terracotta": "fioletova terakota",
  "block.minecraft.blue_terracotta": "modra terakota",
  "block.minecraft.brown_terracotta": "koričneva terakota",
  "block.minecraft.green_terracotta": "zelena terakota",
  "block.minecraft.red_terracotta": "črvena terakota",
  "block.minecraft.black_terracotta": "črna terakota",
  "block.minecraft.barrier": "bariera",
  "block.minecraft.iron_trapdoor": "želězny otvor",
  "block.minecraft.hay_block": "bala sěna",
  "block.minecraft.white_carpet": "běly koverec",
  "block.minecraft.orange_carpet": "oranževy koverec",
  "block.minecraft.magenta_carpet": "purpurny koverec",
  "block.minecraft.light_blue_carpet": "světlomodry koverec",
  "block.minecraft.yellow_carpet": "žolty koverec",
  "block.minecraft.lime_carpet": "jasnozeleny koverec",
  "block.minecraft.pink_carpet": "rozovy koverec",
  "block.minecraft.gray_carpet": "sivy koverec",
  "block.minecraft.light_gray_carpet": "jasnosivy koverec",
  "block.minecraft.cyan_carpet": "turkysovy koverec",
  "block.minecraft.purple_carpet": "fioletovy koverec",
  "block.minecraft.blue_carpet": "modry koverec",
  "block.minecraft.brown_carpet": "koričnevy koverec",
  "block.minecraft.green_carpet": "zeleny koverec",
  "block.minecraft.red_carpet": "črveny koverec",
  "block.minecraft.black_carpet": "črny koverec",
  "block.minecraft.terracotta": "terakota",
  "block.minecraft.coal_block": "blok vugolja",
  "block.minecraft.packed_ice": "izbity led",
  "block.minecraft.acacia_stairs": "akacove stupenišče",
  "block.minecraft.dark_oak_stairs": "mračnodubove stupenišče",
  "block.minecraft.slime_block": "blok sliza",
  "block.minecraft.grass_path": "put",
  "block.minecraft.sunflower": "podsolnuh",
  "block.minecraft.lilac": "boz",
  "block.minecraft.rose_bush": "rozovy kust",
  "block.minecraft.peony": "pivonja",
  "block.minecraft.tall_grass": "vysoka trava",
  "block.minecraft.large_fern": "velika paprat",
  "block.minecraft.white_stained_glass": "bělo steklo",
  "block.minecraft.orange_stained_glass": "oranževo steklo",
  "block.minecraft.magenta_stained_glass": "purpurno steklo",
  "block.minecraft.light_blue_stained_glass": "světlomodro steklo",
  "block.minecraft.yellow_stained_glass": "žolto steklo",
  "block.minecraft.lime_stained_glass": "jasnozeleno steklo",
  "block.minecraft.pink_stained_glass": "rozovo steklo",
  "block.minecraft.gray_stained_glass": "sivo steklo",
  "block.minecraft.light_gray_stained_glass": "jasnosivo steklo",
  "block.minecraft.cyan_stained_glass": "turkysovo steklo",
  "block.minecraft.purple_stained_glass": "fioletovo steklo",
  "block.minecraft.blue_stained_glass": "modro steklo",
  "block.minecraft.brown_stained_glass": "koričnevo steklo",
  "block.minecraft.green_stained_glass": "zeleno steklo",
  "block.minecraft.red_stained_glass": "črveno steklo",
  "block.minecraft.black_stained_glass": "črno steklo",
  "block.minecraft.white_stained_glass_pane": "běly steklěny panel",
  "block.minecraft.orange_stained_glass_pane": "oranževy steklěny panel",
  "block.minecraft.magenta_stained_glass_pane": "purpurny steklěny panel",
  "block.minecraft.light_blue_stained_glass_pane": "světlomodry steklěny panel",
  "block.minecraft.yellow_stained_glass_pane": "žolty steklěny panel",
  "block.minecraft.lime_stained_glass_pane": "jasnozeleny steklěny panel",
  "block.minecraft.pink_stained_glass_pane": "rozovy steklěny panel",
  "block.minecraft.gray_stained_glass_pane": "sivy steklěny panel",
  "block.minecraft.light_gray_stained_glass_pane": "jasnosivy steklěny panel",
  "block.minecraft.cyan_stained_glass_pane": "turkysovy steklěny panel",
  "block.minecraft.purple_stained_glass_pane": "fioletovy steklěny panel",
  "block.minecraft.blue_stained_glass_pane": "modry steklěny panel",
  "block.minecraft.brown_stained_glass_pane": "koričnevy steklěny panel",
  "block.minecraft.green_stained_glass_pane": "zeleny steklěny panel",
  "block.minecraft.red_stained_glass_pane": "črveny steklěny panel",
  "block.minecraft.black_stained_glass_pane": "črny steklěny panel",
  "block.minecraft.prismarine": "prizmarin",
  "block.minecraft.prismarine_bricks": "prizmarinove cegly",
  "block.minecraft.dark_prismarine": "temnoprizmarin",
  "block.minecraft.prismarine_stairs": "prizmarinove stupenišče",
  "block.minecraft.prismarine_brick_stairs": "prizmarinove ceglene stupenišče",
  "block.minecraft.dark_prismarine_stairs": "temnoprizmarinove stupenišče",
  "block.minecraft.sea_lantern": "morska světilka",
  "block.minecraft.red_sandstone": "črveny pěsočny kamenj",
  "block.minecraft.chiseled_red_sandstone": "vrubany črveny pěsočny kamenj",
  "block.minecraft.cut_red_sandstone": "pileny črveny pěsočny kamenj",
  "block.minecraft.red_sandstone_stairs": "črvene pěsočne kamenne stupenišče",
  "block.minecraft.repeating_command_block": "povtarjajuči blok prikazov",
  "block.minecraft.chain_command_block": "poslědovateljny blok prikazov",
  "block.minecraft.magma_block": "blok magmy",
  "block.minecraft.nether_wart_block": "bradavičny blok",
  "block.minecraft.warped_wart_block": "bradavičny izvračeny blok",
  "block.minecraft.red_nether_bricks": "črvene nezerove cegly",
  "block.minecraft.bone_block": "blok kosti",
  "block.minecraft.structure_void": "strukturna prazdnina",
  "block.minecraft.observer": "pogledatnik",
  "block.minecraft.shulker_box": "šalkerova krabka",
  "block.minecraft.white_shulker_box": "běla šalkerova krabka",
  "block.minecraft.orange_shulker_box": "oranževa šalkerova krabka",
  "block.minecraft.magenta_shulker_box": "purpurna šalkerova krabka",
  "block.minecraft.light_blue_shulker_box": "světlomodra šalkerova skrinja",
  "block.minecraft.yellow_shulker_box": "žolta šalkerova krabka",
  "block.minecraft.lime_shulker_box": "jasnozelena šalkerova krabka",
  "block.minecraft.pink_shulker_box": "rozova šalkerova krabka",
  "block.minecraft.gray_shulker_box": "siva šalkerova krabka",
  "block.minecraft.light_gray_shulker_box": "jasnosiva šalkerova krabka",
  "block.minecraft.cyan_shulker_box": "turkysova šalkerova krabka",
  "block.minecraft.purple_shulker_box": "fioletova šalkerova krabka",
  "block.minecraft.blue_shulker_box": "modra šalkerova skrinja",
  "block.minecraft.brown_shulker_box": "koričneva šalkerova krabka",
  "block.minecraft.green_shulker_box": "zelena šalkerova krabka",
  "block.minecraft.red_shulker_box": "črvena šalkerova krabka",
  "block.minecraft.black_shulker_box": "črna šalkerova krabka",
  "block.minecraft.white_glazed_terracotta": "běla glazovana terakota",
  "block.minecraft.orange_glazed_terracotta": "oranževa glazovana terakota",
  "block.minecraft.magenta_glazed_terracotta": "purpurna glazovana terakota",
  "block.minecraft.light_blue_glazed_terracotta": "světlomodra glazovana terakota",
  "block.minecraft.yellow_glazed_terracotta": "žolta glazovana terakota",
  "block.minecraft.lime_glazed_terracotta": "jasnozelena glazovana terakota",
  "block.minecraft.pink_glazed_terracotta": "rozova glazovana terakota",
  "block.minecraft.gray_glazed_terracotta": "siva glazovana terakota",
  "block.minecraft.light_gray_glazed_terracotta": "jasnosiva glazovana terakota",
  "block.minecraft.cyan_glazed_terracotta": "turkysova glazovana terakota",
  "block.minecraft.purple_glazed_terracotta": "fioletova glazovana terakota",
  "block.minecraft.blue_glazed_terracotta": "modra glazovana terakota",
  "block.minecraft.brown_glazed_terracotta": "koričneva glazovana terakota",
  "block.minecraft.green_glazed_terracotta": "zelena glazovana terakota",
  "block.minecraft.red_glazed_terracotta": "črvena glazovana terakota",
  "block.minecraft.black_glazed_terracotta": "črna glazovana terakota",
  "block.minecraft.white_concrete": "běly beton",
  "block.minecraft.orange_concrete": "oranževy beton",
  "block.minecraft.magenta_concrete": "purpurny beton",
  "block.minecraft.light_blue_concrete": "světlomodry beton",
  "block.minecraft.yellow_concrete": "žolty beton",
  "block.minecraft.lime_concrete": "jasnozeleny beton",
  "block.minecraft.pink_concrete": "rozovy beton",
  "block.minecraft.gray_concrete": "sivy beton",
  "block.minecraft.light_gray_concrete": "jasnosivy beton",
  "block.minecraft.cyan_concrete": "turkysovy beton",
  "block.minecraft.purple_concrete": "fioletovy beton",
  "block.minecraft.blue_concrete": "modry beton",
  "block.minecraft.brown_concrete": "koričnevy beton",
  "block.minecraft.green_concrete": "zeleny beton",
  "block.minecraft.red_concrete": "črveny beton",
  "block.minecraft.black_concrete": "črny beton",
  "block.minecraft.white_concrete_powder": "běly cement",
  "block.minecraft.orange_concrete_powder": "oranževy cement",
  "block.minecraft.magenta_concrete_powder": "purpurny cement",
  "block.minecraft.light_blue_concrete_powder": "světlomodry cement",
  "block.minecraft.yellow_concrete_powder": "žolty cement",
  "block.minecraft.lime_concrete_powder": "jasnozeleny cement",
  "block.minecraft.pink_concrete_powder": "rozovy cement",
  "block.minecraft.gray_concrete_powder": "sivy cement",
  "block.minecraft.light_gray_concrete_powder": "jasnosivy cement",
  "block.minecraft.cyan_concrete_powder": "turkysovy cement",
  "block.minecraft.purple_concrete_powder": "fioletovy cement",
  "block.minecraft.blue_concrete_powder": "modry cement",
  "block.minecraft.brown_concrete_powder": "koričnevy cement",
  "block.minecraft.green_concrete_powder": "zeleny cement",
  "block.minecraft.red_concrete_powder": "črveny cement",
  "block.minecraft.black_concrete_powder": "črny cement",
  "block.minecraft.turtle_egg": "jajce žolva",
  "block.minecraft.dead_tube_coral_block": "blok mrtvogo trubčatogo korala",
  "block.minecraft.dead_brain_coral_block": "blok mrtvogo mozgovogo korala",
  "block.minecraft.dead_bubble_coral_block": "blok mrtvogo puhyrčatogo korala",
  "block.minecraft.dead_fire_coral_block": "blok mrtvogo ognjenogo korala",
  "block.minecraft.dead_horn_coral_block": "blok mrtvogo rogovogo korala",
  "block.minecraft.tube_coral_block": "blok trubčatogo korala",
  "block.minecraft.brain_coral_block": "blok mozgovogo korala",
  "block.minecraft.bubble_coral_block": "blok puhyrčatogo korala",
  "block.minecraft.fire_coral_block": "blok ognjenogo korala",
  "block.minecraft.horn_coral_block": "blok rogovogo korala",
  "block.minecraft.tube_coral": "cěvkovy koral",
  "block.minecraft.brain_coral": "mozgovy koral",
  "block.minecraft.bubble_coral": "bublinovy koral",
  "block.minecraft.fire_coral": "ognjeny koral",
  "block.minecraft.horn_coral": "rogovy koral",
  "block.minecraft.dead_brain_coral": "mrtvy mozgovy koral",
  "block.minecraft.dead_bubble_coral": "mrtvy bublinovy koral",
  "block.minecraft.dead_fire_coral": "mrtvy ognjeny koral",
  "block.minecraft.dead_horn_coral": "mrtvy rogovy koral",
  "block.minecraft.dead_tube_coral": "mrtvy trubčaty koral",
  "block.minecraft.tube_coral_fan": "vějarny trubčaty koral",
  "block.minecraft.brain_coral_fan": "vějarny mozgovy koral",
  "block.minecraft.bubble_coral_fan": "vějarny puhyrčaty koral",
  "block.minecraft.fire_coral_fan": "vějarny žžemy koral",
  "block.minecraft.horn_coral_fan": "vějarny rogovy koral",
  "block.minecraft.dead_tube_coral_fan": "mrtvy vějarny trubčaty koral",
  "block.minecraft.dead_brain_coral_fan": "mrtvy vějarny mozgovy koral",
  "block.minecraft.dead_bubble_coral_fan": "mtrvy vějarny puhyrčaty koral",
  "block.minecraft.dead_fire_coral_fan": "mrtvy vějarny ognjeny koral",
  "block.minecraft.dead_horn_coral_fan": "mrtvy vějarny rogovy koral",
  "block.minecraft.blue_ice": "modry led",
  "block.minecraft.conduit": "morska srdcevina",
  "block.minecraft.polished_granite_stairs": "polirane granitove stupenišče",
  "block.minecraft.smooth_red_sandstone_stairs": "gladke črvene pěsočne kamenne stupenišče",
  "block.minecraft.mossy_stone_brick_stairs": "travne kamenne ceglene stupenišče",
  "block.minecraft.polished_diorite_stairs": "polirane dioritove stupenišče",
  "block.minecraft.mossy_cobblestone_stairs": "travne podělene kamenne stupenišče",
  "block.minecraft.end_stone_brick_stairs": "kamenne ceglene stupenišče enda",
  "block.minecraft.stone_stairs": "kamenne stupenišče",
  "block.minecraft.smooth_sandstone_stairs": "gladke pěsočne kamenne stupenišče",
  "block.minecraft.smooth_quartz_stairs": "gladke kvarcove stupenišče",
  "block.minecraft.granite_stairs": "granitove stupenišče",
  "block.minecraft.andesite_stairs": "andezitove stupenišče",
  "block.minecraft.red_nether_brick_stairs": "črvene nezerove stupenišče",
  "block.minecraft.polished_andesite_stairs": "polirane andezitove stupenišče",
  "block.minecraft.diorite_stairs": "dioritove stupenišče",
  "block.minecraft.polished_granite_slab": "polirany granitovy platform",
  "block.minecraft.smooth_red_sandstone_slab": "gladky črveny pěsočny kamenny platform",
  "block.minecraft.mossy_stone_brick_slab": "travny kamenny cegleny platform",
  "block.minecraft.polished_diorite_slab": "polirany dioritovy platform",
  "block.minecraft.mossy_cobblestone_slab": "travny poděleny kamenny platform",
  "block.minecraft.end_stone_brick_slab": "kamenny cegleny platform enda",
  "block.minecraft.smooth_sandstone_slab": "gladky pěsočny kamenny platform",
  "block.minecraft.smooth_quartz_slab": "gladky kvarcovy platform",
  "block.minecraft.granite_slab": "granitovy platform",
  "block.minecraft.andesite_slab": "andezitovy platform",
  "block.minecraft.red_nether_brick_slab": "črveny nezerovy platform",
  "block.minecraft.polished_andesite_slab": "polirany andezitovy platform",
  "block.minecraft.diorite_slab": "dioritovy platform",
  "block.minecraft.scaffolding": "fasadarja",
  "block.minecraft.iron_door": "želězne dveri",
  "block.minecraft.oak_door": "dubove dveri",
  "block.minecraft.spruce_door": "smrěkove dveri",
  "block.minecraft.birch_door": "brězove dveri",
  "block.minecraft.jungle_door": "džunglove dveri",
  "block.minecraft.acacia_door": "akacove dveri",
  "block.minecraft.dark_oak_door": "mračnodubove dveri",
  "block.minecraft.crimson_door": "bagrove dveri",
  "block.minecraft.warped_door": "izvračene dveri",
  "block.minecraft.repeater": "redstounovy povtarjatel",
  "block.minecraft.comparator": "redstounovy sravnjatel",
  "block.minecraft.structure_block": "blok struktur",
  "block.minecraft.jigsaw": "vezatnik",
  "item.minecraft.turtle_helmet": "pancyr žolva□□kogda na glavě:□+ 2 bronja",
  "item.minecraft.scute": "zaščitka",
  "item.minecraft.iron_shovel": "želězna lopata□□kogda v glavnoj rukě:□+ 3.5 poškodženje ataky□-3 bystrost ataky",
  "item.minecraft.iron_pickaxe": "želězna kopalka□□kogda v glavnoj rukě:□+ 3 poškodženje ataky□-2.8 bystrost ataky",
  "item.minecraft.iron_axe": "želězna sěkyra□□kogda v glavnoj rukě:□+ 8 poškodženje ataky□-3.1 bystrost ataky",
  "item.minecraft.flint_and_steel": "zapalnička",
  "item.minecraft.apple": "jabloko",
  "item.minecraft.bow": "luk",
  "item.minecraft.arrow": "strěla",
  "item.minecraft.coal": "vugolj",
  "item.minecraft.charcoal": "drěvny vugolj",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "želězny kovok",
  "item.minecraft.gold_ingot": "zlaty kovok",
  "item.minecraft.netherite_ingot": "nezeritovy kovok",
  "item.minecraft.netherite_scrap": "kus nezerita",
  "item.minecraft.iron_sword": "želězny meč□□kogda v glavnoj rukě:□+ 5 poškodženje ataky□-2.4 bystrost ataky",
  "item.minecraft.wooden_sword": "drěvěny meč□□kogda v glavnoj rukě:□+ 3 poškodženje ataky□-2.4 bystrost ataky",
  "item.minecraft.wooden_shovel": "drěvěna lopata□□kogda v glavnoj rukě:□+ 1.5 poškodženje ataky□-3 bystrost ataky",
  "item.minecraft.wooden_pickaxe": "drěvěna kopalka□□kogda v glavnoj rukě:□+ 1 poškodženje ataky□-2.8 bystrost ataky",
  "item.minecraft.wooden_axe": "drěvěna sěkyra□□kogda v glavnoj rukě:□+ 6 poškodženje ataky□-3.2 bystrost ataky",
  "item.minecraft.stone_sword": "kamenny meč□□kogda v glavnoj rukě:□+ 4 poškodženje ataky□-2.4 bystrost ataky",
  "item.minecraft.stone_shovel": "kamenna lopata□□kogda v glavnoj rukě:□+ 2.5 poškodženje ataky□-3 bystrost ataky",
  "item.minecraft.stone_pickaxe": "kamenna kopalka□□kogda v glavnoj rukě:□+ 2 poškodženje ataky□-2.8 bystrost ataky",
  "item.minecraft.stone_axe": "kamenna sěkyra□□kogda v glavnoj rukě:□+ 8 poškodženje ataky□-3.2 bystrost ataky",
  "item.minecraft.diamond_sword": "diamantovy meč□□kogda v glavnoj rukě:□+ 6 poškodženje ataky□-2.4 bystrost ataky",
  "item.minecraft.diamond_shovel": "diamantova lopata□□kogda v glavnoj rukě:□+ 4.5 poškodženje ataky□-3 bystrost ataky",
  "item.minecraft.diamond_pickaxe": "diamantova kopalka□□kogda v glavnoj rukě:□+ 4 poškodženje ataky□-2.8 bystrost ataky",
  "item.minecraft.diamond_axe": "diamantova sěkyra□□kogda v glavnoj rukě:□+ 8 poškodženje ataky□-3 bystrost ataky",
  "item.minecraft.stick": "pala",
  "item.minecraft.bowl": "miska",
  "item.minecraft.mushroom_stew": "gribna supa",
  "item.minecraft.golden_sword": "zlaty meč□□kogda v glavnoj rukě:□+ 3 poškodženje ataky□-2.4 bystrost ataky",
  "item.minecraft.golden_shovel": "zlata lopata□□kogda v glavnoj rukě:□+ 1.5 poškodženje ataky□-3 bystrost ataky",
  "item.minecraft.golden_pickaxe": "zlata kopalka□□kogda v glavnoj rukě:□+ 1 poškodženje ataky□-2.8 bystrost ataky",
  "item.minecraft.golden_axe": "zlata sěkyra□□kogda v glavnoj rukě:□+ 6 poškodženje ataky□-3 bystrost ataky",
  "item.minecraft.netherite_sword": "nezeritovy meč□□kogda v glavnoj rukě:□+ 7 poškodženje ataky□-2.4 bystrost ataky",
  "item.minecraft.netherite_shovel": "nezeritova lopata□□kogda v glavnoj rukě:□+ 5.5 poškodženje ataky□-3 bystrost ataky",
  "item.minecraft.netherite_pickaxe": "nezeritova kopalka□□kogda v glavnoj rukě:□+ 5 poškodženje ataky□-2.8 bystrost ataky",
  "item.minecraft.netherite_axe": "nezeritova sěkyra□□kogda v glavnoj rukě:□+ 9 poškodženje ataky□-3 bystrost ataky",
  "item.minecraft.string": "nit",
  "item.minecraft.feather": "pero",
  "item.minecraft.gunpowder": "izbuhlivy prah",
  "item.minecraft.wooden_hoe": "drěvěna motyka□□kogda v glavnoj rukě:□-3 bystrost ataky",
  "item.minecraft.stone_hoe": "kamenna motyka□□kogda v glavnoj rukě:□-2 bystrost ataky",
  "item.minecraft.iron_hoe": "želězna motyka□□kogda v glavnoj rukě:□-1 bystrost ataky",
  "item.minecraft.diamond_hoe": "diamantova motyka□□kogda v glavnoj rukě:",
  "item.minecraft.golden_hoe": "zlata motyka□□kogda v glavnoj rukě:□-3 bystrost ataky",
  "item.minecraft.netherite_hoe": "nezeritova motyka□□kogda v glavnoj rukě:",
  "item.minecraft.wheat_seeds": "sěme pšenice",
  "item.minecraft.wheat": "pšenica",
  "item.minecraft.bread": "hlěb",
  "item.minecraft.leather_helmet": "kožena šapka□□kogda na glavě:□+ 1 bronja",
  "item.minecraft.leather_chestplate": "koženy plašč□□kogda na tělu:□+ 3 bronja",
  "item.minecraft.leather_leggings": "kožene nogavky□□kogda na nogah:□+ 2 bronja",
  "item.minecraft.leather_boots": "kožene obuvky□□kogda na stopah:□+ 1 bronja",
  "item.minecraft.chainmail_helmet": "lancovany šlěm□□kogda na glavě:□+ 2 bronja",
  "item.minecraft.chainmail_chestplate": "lancovany nagrudnik□□kogda na tělu:□+ 5 bronja",
  "item.minecraft.chainmail_leggings": "lancovane nogavice□□kogda na nogah:□+ 4 bronja",
  "item.minecraft.chainmail_boots": "lancovane obuvky□□kogda na stopah:□+ 1 bronja",
  "item.minecraft.iron_helmet": "železny šlěm□□kogda na glavě:□+ 2 bronja",
  "item.minecraft.iron_chestplate": "železny nagrudnik□□kogda na tělu:□+ 6 bronja",
  "item.minecraft.iron_leggings": "železne nogavice□□kogda na nogah:□+ 5 bronja",
  "item.minecraft.iron_boots": "železne obuvky□□kogda na stopah:□+ 2 bronja",
  "item.minecraft.diamond_helmet": "diamantovy šlěm□□kogda na glavě:□+ 3 bronja□+ 2 sila bronji",
  "item.minecraft.diamond_chestplate": "diamantovy nagrudnik□□kogda na tělu:□+ 8 bronja□+ 2 sila bronji",
  "item.minecraft.diamond_leggings": "diamantove nogavice□□kogda na nogah:□+ 6 bronja□+ 2 sila bronji",
  "item.minecraft.diamond_boots": "diamantove obuvky□□kogda na stopah:□+ 3 bronja□+ 2 sila bronji",
  "item.minecraft.golden_helmet": "zlaty šlěm□□kogda na glavě:□+ 2 bronja",
  "item.minecraft.golden_chestplate": "zlaty nagrudnik□□kogda na tělu:□+ 5 bronja",
  "item.minecraft.golden_leggings": "zlate nogavice□□kogda na nogah:□+ 3 bronja",
  "item.minecraft.golden_boots": "zlate obuvky□□kogda na stopah:□+ 1 bronja",
  "item.minecraft.netherite_helmet": "nezeritovy šlěm□□kogda na glavě:□+ 3 bronja□+ 3 sila bronji□+ 1 protivdějstvo odphajuče",
  "item.minecraft.netherite_chestplate": "nezeritovy nagrudnik□□kogda na tělu:□+ 8 bronja□+ 3 sila bronji□+ 1 protivdějstvo odphajuče",
  "item.minecraft.netherite_leggings": "nezeritove nogavice□□kogda na nogah:□+ 6 bronja□+ 3 sila bronji□+ 1 protivdějstvo odphajuče",
  "item.minecraft.netherite_boots": "nezeritove obuvky□□kogda na stopah:□+ 3 bronja□+ 3 sila bronji□+ 1 protivdějstvo odphajuče",
  "item.minecraft.flint": "kremenj",
  "item.minecraft.porkchop": "surova veprina",
  "item.minecraft.cooked_porkchop": "pečena veprina",
  "item.minecraft.painting": "obraz",
  "item.minecraft.golden_apple": "zlato jabloko",
  "item.minecraft.enchanted_golden_apple": "čarovno zlato jabloko",
  "block.minecraft.oak_sign": "dubova vyvěska",
  "block.minecraft.spruce_sign": "smrěkova vyvěska",
  "block.minecraft.birch_sign": "brězova vyvěska",
  "block.minecraft.jungle_sign": "džunglova vyvěska",
  "block.minecraft.acacia_sign": "akacova vyvěska",
  "block.minecraft.dark_oak_sign": "mračnodubova vyvěska",
  "block.minecraft.crimson_sign": "bagrova vyvěska",
  "block.minecraft.warped_sign": "izvračena vyvěska",
  "item.minecraft.bucket": "vědro",
  "item.minecraft.water_bucket": "vědro s vodoju",
  "item.minecraft.lava_bucket": "vědro s lavoju",
  "item.minecraft.minecart": "vagonetka",
  "item.minecraft.saddle": "sedlo",
  "item.minecraft.redstone": "redstoun",
  "item.minecraft.snowball": "kalina",
  "item.minecraft.oak_boat": "dubova lodka",
  "item.minecraft.leather": "koža",
  "item.minecraft.milk_bucket": "vědro s mlěkom",
  "item.minecraft.pufferfish_bucket": "vědro s naduvačem",
  "item.minecraft.salmon_bucket": "vědro s lososem",
  "item.minecraft.cod_bucket": "vědro s treskoju",
  "item.minecraft.tropical_fish_bucket": "vědro s tropičnoju ryboju",
  "item.minecraft.brick": "cegla",
  "item.minecraft.clay_ball": "glina",
  "block.minecraft.dried_kelp_block": "blok suhovodorastov",
  "item.minecraft.paper": "papir",
  "item.minecraft.book": "kniga",
  "item.minecraft.slime_ball": "kulja sliza",
  "item.minecraft.chest_minecart": "vagonetka so skrinjoju",
  "item.minecraft.furnace_minecart": "vagonetka s pečem",
  "item.minecraft.egg": "jajce",
  "item.minecraft.compass": "kompas",
  "item.minecraft.fishing_rod": "vudačka",
  "item.minecraft.clock": "časovnik",
  "item.minecraft.glowstone_dust": "světlokamenny prah",
  "item.minecraft.cod": "surova treska",
  "item.minecraft.salmon": "surovy losos",
  "item.minecraft.tropical_fish": "tropična ryba",
  "item.minecraft.pufferfish": "naduvač",
  "item.minecraft.cooked_cod": "pečena treska",
  "item.minecraft.cooked_salmon": "pečeny losos",
  "item.minecraft.ink_sac": "měšek so črnilom",
  "item.minecraft.red_dye": "črvena farba",
  "item.minecraft.green_dye": "zelena farba",
  "item.minecraft.cocoa_beans": "kakaove zrno",
  "item.minecraft.lapis_lazuli": "lazurit",
  "item.minecraft.purple_dye": "fioletova farba",
  "item.minecraft.cyan_dye": "turkysova farba",
  "item.minecraft.light_gray_dye": "jasnosiva farba",
  "item.minecraft.gray_dye": "siva farba",
  "item.minecraft.pink_dye": "rozova farba",
  "item.minecraft.lime_dye": "jasnozelena farba",
  "item.minecraft.yellow_dye": "žolta farba",
  "item.minecraft.light_blue_dye": "světlomodra farba",
  "item.minecraft.magenta_dye": "purpurna farba",
  "item.minecraft.orange_dye": "oranževa farba",
  "item.minecraft.bone_meal": "kostna muka",
  "item.minecraft.blue_dye": "modra farba",
  "item.minecraft.brown_dye": "koričneva farba",
  "item.minecraft.black_dye": "črna farba",
  "item.minecraft.white_dye": "běla farba",
  "item.minecraft.bone": "kost",
  "item.minecraft.sugar": "cukr",
  "block.minecraft.cake": "tort",
  "block.minecraft.white_bed": "bělo ležišče",
  "block.minecraft.orange_bed": "oranževo ležišče",
  "block.minecraft.magenta_bed": "purpurno ležišče",
  "block.minecraft.light_blue_bed": "světlomodro ležišče",
  "block.minecraft.yellow_bed": "žolto ležišče",
  "block.minecraft.lime_bed": "jasnozeleno ležišče",
  "block.minecraft.pink_bed": "rozovo ležišče",
  "block.minecraft.gray_bed": "sivo ležišče",
  "block.minecraft.light_gray_bed": "jasnosivo ležišče",
  "block.minecraft.cyan_bed": "turkysovo ležišče",
  "block.minecraft.purple_bed": "fioletovo ležišče",
  "block.minecraft.blue_bed": "modro ležišče",
  "block.minecraft.brown_bed": "koričnevo ležišče",
  "block.minecraft.green_bed": "zeleno ležišče",
  "block.minecraft.red_bed": "črveno ležišče",
  "block.minecraft.black_bed": "črno ležišče",
  "item.minecraft.cookie": "biskvit",
  "item.minecraft.filled_map": "mapa□#0",
  "item.minecraft.shears": "nožice",
  "item.minecraft.melon_slice": "kusok dynje",
  "item.minecraft.dried_kelp": "sušena vodna trava",
  "item.minecraft.pumpkin_seeds": "sěme tykvy",
  "item.minecraft.melon_seeds": "sěme dynje",
  "item.minecraft.beef": "surova govedina",
  "item.minecraft.cooked_beef": "bifštek",
  "item.minecraft.chicken": "surova kura",
  "item.minecraft.cooked_chicken": "pečena kura",
  "item.minecraft.rotten_flesh": "gnilo meso",
  "item.minecraft.ender_pearl": "ender-perla",
  "item.minecraft.blaze_rod": "plamenjcovy prut",
  "item.minecraft.ghast_tear": "solza gasta",
  "item.minecraft.gold_nugget": "zlaty samorod",
  "item.minecraft.nether_wart": "nezerova bradavica",
  "item.minecraft.potion": "neizrabotatelny napitok□nemaje efektov",
  "item.minecraft.glass_bottle": "steklěna fljaška",
  "item.minecraft.spider_eye": "oko pavuka",
  "item.minecraft.fermented_spider_eye": "izkvašeno oko pavuka",
  "item.minecraft.blaze_powder": "plamenjcovy prah",
  "item.minecraft.magma_cream": "magmovy krem",
  "block.minecraft.brewing_stand": "napitnik",
  "block.minecraft.cauldron": "kotel",
  "item.minecraft.ender_eye": "oko endera",
  "item.minecraft.glistering_melon_slice": "kusok blěskajučej dynje",
  "item.minecraft.bat_spawn_egg": "jajce s lětajučoju myšju",
  "item.minecraft.bee_spawn_egg": "jajce s pčeloju",
  "item.minecraft.blaze_spawn_egg": "jajce s plamenjcem",
  "item.minecraft.cat_spawn_egg": "jajce s kotom",
  "item.minecraft.cave_spider_spawn_egg": "jajce s jamovym pavukom",
  "item.minecraft.chicken_spawn_egg": "jajce s kuroju",
  "item.minecraft.cod_spawn_egg": "jajce s treskoju",
  "item.minecraft.cow_spawn_egg": "jajce s kravoju",
  "item.minecraft.creeper_spawn_egg": "jajce s kriperom",
  "item.minecraft.dolphin_spawn_egg": "jajce s delfinom",
  "item.minecraft.donkey_spawn_egg": "jajce s oslom",
  "item.minecraft.drowned_spawn_egg": "jajce s utonenjcem",
  "item.minecraft.elder_guardian_spawn_egg": "jajce s prastražem",
  "item.minecraft.enderman_spawn_egg": "jajce s endermanom",
  "item.minecraft.endermite_spawn_egg": "jajce s endermitom",
  "item.minecraft.evoker_spawn_egg": "jajce s privoditeljem",
  "item.minecraft.fox_spawn_egg": "jajce s lisom",
  "item.minecraft.ghast_spawn_egg": "jajce s gastom",
  "item.minecraft.guardian_spawn_egg": "jajce so stražem",
  "item.minecraft.hoglin_spawn_egg": "jajce s hoglinom",
  "item.minecraft.horse_spawn_egg": "jajce s konjem",
  "item.minecraft.husk_spawn_egg": "jajce s pustynnikom",
  "item.minecraft.llama_spawn_egg": "jajce s lamoju",
  "item.minecraft.magma_cube_spawn_egg": "jajce s kostkoju magmy",
  "item.minecraft.mooshroom_spawn_egg": "jajce s mušrumom",
  "item.minecraft.mule_spawn_egg": "jajce s mulom",
  "item.minecraft.ocelot_spawn_egg": "jajce s ocelotom",
  "item.minecraft.panda_spawn_egg": "jace s pandoju",
  "item.minecraft.parrot_spawn_egg": "jajce s papugajem",
  "item.minecraft.phantom_spawn_egg": "jajce s prizrakom",
  "item.minecraft.pig_spawn_egg": "jajce so svinjoju",
  "item.minecraft.piglin_spawn_egg": "jajce s piglinom",
  "item.minecraft.pillager_spawn_egg": "jajce s razbojnikom",
  "item.minecraft.polar_bear_spawn_egg": "jajce s polarnym medvědom",
  "item.minecraft.pufferfish_spawn_egg": "jajce s naduvačem",
  "item.minecraft.rabbit_spawn_egg": "jajce s kralikom",
  "item.minecraft.ravager_spawn_egg": "jajce s niščiteljem",
  "item.minecraft.salmon_spawn_egg": "jajce s lososom",
  "item.minecraft.sheep_spawn_egg": "jajce s ovcoju",
  "item.minecraft.shulker_spawn_egg": "jajce so šalkerom",
  "item.minecraft.silverfish_spawn_egg": "jajce s rybikom",
  "item.minecraft.skeleton_spawn_egg": "jajce so skeletom",
  "item.minecraft.skeleton_horse_spawn_egg": "jajce s konjskym skeletom",
  "item.minecraft.slime_spawn_egg": "jajce so slizecom",
  "item.minecraft.spider_spawn_egg": "jajce so pavukom",
  "item.minecraft.squid_spawn_egg": "jajce so sprutom",
  "item.minecraft.stray_spawn_egg": "jajce s bluditeljem",
  "item.minecraft.strider_spawn_egg": "jajce s lavohodom",
  "item.minecraft.trader_llama_spawn_egg": "jajce s lamoju kupca",
  "item.minecraft.tropical_fish_spawn_egg": "jajce s tropičnoju ryboju",
  "item.minecraft.turtle_spawn_egg": "jajce so žolvoju",
  "item.minecraft.vex_spawn_egg": "jajce s ogorčateljem",
  "item.minecraft.villager_spawn_egg": "jajce so seljanom",
  "item.minecraft.vindicator_spawn_egg": "jajce so mstiteljem",
  "item.minecraft.wandering_trader_spawn_egg": "jajce s putujučim kupcem",
  "item.minecraft.witch_spawn_egg": "jajce s vědmoju",
  "item.minecraft.wither_skeleton_spawn_egg": "jajce s vizerovym skeletom",
  "item.minecraft.wolf_spawn_egg": "jajce s volkom",
  "item.minecraft.zoglin_spawn_egg": "jajce so zoglinom",
  "item.minecraft.zombie_spawn_egg": "jajce s zombeju",
  "item.minecraft.zombie_horse_spawn_egg": "jajce s konjem zombeju",
  "item.minecraft.zombie_villager_spawn_egg": "jajce so seljanom zombeju",
  "item.minecraft.zombified_piglin_spawn_egg": "jajce so zombizovanym piglinom",
  "item.minecraft.experience_bottle": "čarovna fljaška",
  "item.minecraft.fire_charge": "ognjena kulja",
  "item.minecraft.writable_book": "kniga s perom",
  "item.minecraft.written_book": "zapisana kniga",
  "item.minecraft.emerald": "smaragd",
  "item.minecraft.item_frame": "oprava na prědmet",
  "block.minecraft.flower_pot": "cvětny grn",
  "item.minecraft.carrot": "mrkva",
  "item.minecraft.potato": "kartofelj",
  "item.minecraft.baked_potato": "pečeny kartofelj",
  "item.minecraft.poisonous_potato": "otravny kartofelj",
  "item.minecraft.map": "pusta mapa",
  "item.minecraft.golden_carrot": "zlata mrkva",
  "block.minecraft.skeleton_skull": "čerep skeleta",
  "block.minecraft.wither_skeleton_skull": "čerep vizerovogo skeleta",
  "block.minecraft.player_head": "glava igrača",
  "block.minecraft.zombie_head": "glava zombe",
  "block.minecraft.creeper_head": "glava kripera",
  "block.minecraft.dragon_head": "glava drakona",
  "item.minecraft.carrot_on_a_stick": "mrkva na palě",
  "item.minecraft.warped_fungus_on_a_stick": "izvačeny grib na palě",
  "item.minecraft.nether_star": "zvězda nezera",
  "item.minecraft.pumpkin_pie": "tykvova galeta",
  "item.minecraft.firework_rocket": "fejerverk",
  "item.minecraft.firework_star": "zvězdka pirotehnična",
  "item.minecraft.enchanted_book": "čarovna kniga",
  "item.minecraft.nether_brick": "nezerova cegla",
  "item.minecraft.quartz": "kvarc nezera",
  "item.minecraft.tnt_minecart": "vagonetka s tnt",
  "item.minecraft.hopper_minecart": "vagonetka s nasypnikom",
  "item.minecraft.prismarine_shard": "črěp prizmarina",
  "item.minecraft.prismarine_crystals": "kristaly prizmarina",
  "item.minecraft.rabbit": "surovy kralik",
  "item.minecraft.cooked_rabbit": "pečeny kralik",
  "item.minecraft.rabbit_stew": "supa iz kralika",
  "item.minecraft.rabbit_foot": "lapa kralika",
  "item.minecraft.rabbit_hide": "koža kralika",
  "item.minecraft.armor_stand": "stojak za bronju",
  "item.minecraft.iron_horse_armor": "želězna konska bronja",
  "item.minecraft.golden_horse_armor": "zlata konska bronja",
  "item.minecraft.diamond_horse_armor": "diamantova konska bronja",
  "item.minecraft.leather_horse_armor": "kožena konska bronja",
  "item.minecraft.lead": "vodilo",
  "item.minecraft.name_tag": "imenna značka",
  "item.minecraft.command_block_minecart": "vagonetka s blokom prikazov",
  "item.minecraft.mutton": "surova baranina",
  "item.minecraft.cooked_mutton": "pečena baranina",
  "block.minecraft.white_banner": "běla horugva",
  "block.minecraft.orange_banner": "oranževa horugva",
  "block.minecraft.magenta_banner": "purpurna horugva",
  "block.minecraft.light_blue_banner": "světlomodra horugva",
  "block.minecraft.yellow_banner": "žolta horugva",
  "block.minecraft.lime_banner": "jasnozelena horugva",
  "block.minecraft.pink_banner": "rozova horugva",
  "block.minecraft.gray_banner": "siva horugva",
  "block.minecraft.light_gray_banner": "jasnosiva horugva",
  "block.minecraft.cyan_banner": "turkysova horugva",
  "block.minecraft.purple_banner": "fioletova horugva",
  "block.minecraft.blue_banner": "modra horugva",
  "block.minecraft.brown_banner": "koričneva horugva",
  "block.minecraft.green_banner": "zelena horugva",
  "block.minecraft.red_banner": "črvena horugva",
  "block.minecraft.black_banner": "črna horugva",
  "item.minecraft.end_crystal": "endovy kristal",
  "item.minecraft.chorus_fruit": "ovoč horusa",
  "item.minecraft.popped_chorus_fruit": "vypukany ovoč horusa",
  "item.minecraft.beetroot": "cvekla",
  "item.minecraft.beetroot_seeds": "sěme cvekly",
  "item.minecraft.beetroot_soup": "boršč",
  "item.minecraft.dragon_breath": "dyh drakona",
  "item.minecraft.splash_potion": "metany neizvodlivy napitok□nemaje efektov",
  "item.minecraft.spectral_arrow": "prividna strěla",
  "item.minecraft.tipped_arrow": "neizrabotatelna namočena strěla□nemaje efektov",
  "item.minecraft.lingering_potion": "dolgotrajny neizvodlivy napitok□nemaje efektov",
  "item.minecraft.shield": "ščit",
  "item.minecraft.elytra": "elitra",
  "item.minecraft.spruce_boat": "smrěkova lodka",
  "item.minecraft.birch_boat": "brězova lodka",
  "item.minecraft.jungle_boat": "džunglova lodka",
  "item.minecraft.acacia_boat": "akacova lodka",
  "item.minecraft.dark_oak_boat": "mračnodubova lodka",
  "item.minecraft.totem_of_undying": "totem nesmrteljnosti",
  "item.minecraft.shulker_shell": "skorlupa šalkera",
  "item.minecraft.iron_nugget": "želězny samorod",
  "item.minecraft.knowledge_book": "kniga vědy",
  "item.minecraft.debug_stick": "debugujuča pala",
  "item.minecraft.music_disc_13": "muzikalny disk□c418 - 13",
  "item.minecraft.music_disc_cat": "muzikalny disk□c418 - cat",
  "item.minecraft.music_disc_blocks": "muzikalny disk□c418 - blocks",
  "item.minecraft.music_disc_chirp": "muzikalny disk□c418 - chirp",
  "item.minecraft.music_disc_far": "muzikalny disk□c418 - far",
  "item.minecraft.music_disc_mall": "muzikalny disk□c418 - mall",
  "item.minecraft.music_disc_mellohi": "muzikalny disk□c418 - mellohi",
  "item.minecraft.music_disc_stal": "muzikalny disk□c418 - stal",
  "item.minecraft.music_disc_strad": "muzikalny disk□c418 - strad",
  "item.minecraft.music_disc_ward": "muzikalny disk□c418 - ward",
  "item.minecraft.music_disc_11": "muzikalny disk□c418 - 11",
  "item.minecraft.music_disc_wait": "muzikalny disk□c418 - wait",
  "item.minecraft.music_disc_pigstep": "muzikalny disk□lena raine - pigstep",
  "item.minecraft.trident": "trizubec□□kogda v glavnoj rukě:□+ 8 poškodženje ataky□-2.9 bystrost ataky",
  "item.minecraft.phantom_membrane": "blana prizraka",
  "item.minecraft.nautilus_shell": "skorlupa nautilusa",
  "item.minecraft.heart_of_the_sea": "morsko srdce",
  "item.minecraft.crossbow": "samostrel",
  "item.minecraft.suspicious_stew": "podzrěna supa",
  "block.minecraft.loom": "stanok",
  "item.minecraft.flower_banner_pattern": "črtež horugvy□črtež cvěta",
  "item.minecraft.creeper_banner_pattern": "črtež horugvy□črtež kripera",
  "item.minecraft.skull_banner_pattern": "črtež horugvy□črtež čerepa",
  "item.minecraft.mojang_banner_pattern": "črtež horugvy□prědmet",
  "item.minecraft.globe_banner_pattern": "črtež horugvy□globus",
  "item.minecraft.piglin_banner_pattern": "črtež horugvy□rylo",
  "block.minecraft.composter": "kompostnik",
  "block.minecraft.barrel": "bočka",
  "block.minecraft.smoker": "zapeč",
  "block.minecraft.blast_furnace": "goreči peč",
  "block.minecraft.cartography_table": "kartografičny stol",
  "block.minecraft.fletching_table": "stol do produkcije strěl",
  "block.minecraft.grindstone": "brus",
  "block.minecraft.lectern": "pult",
  "block.minecraft.smithing_table": "kovačsky stol",
  "block.minecraft.stonecutter": "kamenosěkator",
  "block.minecraft.bell": "zvon",
  "block.minecraft.lantern": "světilka",
  "block.minecraft.soul_lantern": "světilka duš",
  "item.minecraft.sweet_berries": "sladke brusnice",
  "block.minecraft.campfire": "taborny ogonj",
  "block.minecraft.soul_campfire": "taborny ogonj duš",
  "block.minecraft.shroomlight": "světlogrib",
  "item.minecraft.honeycomb": "šestikutnik pčel",
  "block.minecraft.bee_nest": "brt",
  "block.minecraft.beehive": "ulja",
  "item.minecraft.honey_bottle": "fljaška meda",
  "block.minecraft.honey_block": "medovy blok",
  "block.minecraft.honeycomb_block": "sotovny blok",
  "block.minecraft.lodestone": "magnetit",
  "block.minecraft.netherite_block": "blok nezerita",
  "block.minecraft.ancient_debris": "drěvny ulomok",
  "block.minecraft.target": "strěljaj-ščit",
  "block.minecraft.crying_obsidian": "plačajuči obsidian",
  "block.minecraft.blackstone": "črnit",
  "block.minecraft.blackstone_slab": "črnitovy platform",
  "block.minecraft.blackstone_stairs": "črnitove stupenišče",
  "block.minecraft.gilded_blackstone": "pozlačeny črnit",
  "block.minecraft.polished_blackstone": "polirany črnit",
  "block.minecraft.polished_blackstone_slab": "polirany črnitovy platform",
  "block.minecraft.polished_blackstone_stairs": "polirane črnitove stupenišče",
  "block.minecraft.chiseled_polished_blackstone": "vrubany polirany črnit",
  "block.minecraft.polished_blackstone_bricks": "polirane črnitove cegly",
  "block.minecraft.polished_blackstone_brick_slab": "polirany črnitovy cegleny platform",
  "block.minecraft.polished_blackstone_brick_stairs": "polirane črnitove ceglene stupenišče",
  "block.minecraft.cracked_polished_blackstone_bricks": "razdrobjene polirane črnitove cegly",
  "block.minecraft.respawn_anchor": "prěrodeča kotva",
}
export const isv = items; 
